// src/design/forms/datepicker/calendar-carburettor/zero-pad/index.ts
var e = (e) => e > 9 ? `${e}` : `0${e}`;
export { e as zero_pad };

//# sourceMappingURL=index.js.map